module.exports = __webpack_public_path__ + "img/save-icon.69b4adbb.svg";